import { VFileInput } from 'vuetify/lib/components/VFileInput';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFileInput,{attrs:{"accept":_vm.allowedFileTypes,"label":_vm.label,"multiple":_vm.allowMultiple,"outlined":"","rules":_vm.fileRules,"dense":"","small-chips":""},on:{"change":_vm.handleFileChange},model:{value:(_vm.internalFiles),callback:function ($$v) {_vm.internalFiles=$$v},expression:"internalFiles"}})}
var staticRenderFns = []

export { render, staticRenderFns }